var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star",
    clipPath: "url(#clip0_302_773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5441 19.4888L9.99999 16.0195L4.45589 19.4888C4.25448 19.6164 3.99468 19.6067 3.80073 19.4659C3.60734 19.3257 3.51863 19.082 3.57698 18.8502L5.16312 12.505L0.209524 8.30508C0.0263987 8.15172 -0.0451248 7.90223 0.0287034 7.67508C0.102531 7.44735 0.307375 7.2877 0.545422 7.2711L7.01081 6.81961L9.4564 0.753677C9.63609 0.310786 10.3639 0.310786 10.5436 0.753677L12.9892 6.81961L19.4546 7.2711C19.6926 7.2877 19.8975 7.44735 19.9713 7.67508C20.0451 7.90223 19.9736 8.15172 19.7905 8.30508L14.8368 12.5051L16.423 18.8503C16.4813 19.082 16.3926 19.3258 16.1992 19.466C16.0013 19.6097 15.7422 19.613 15.5441 19.4888Z",
    fill: "#C9C9C9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star-1.30533d1a22d6d1c7c0e668591d5f860b.svg";
export { ForwardRef as ReactComponent };